import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { CommonModule } from '@angular/common';
import { IThreatAssessmentTeam } from '../../../shared/models/contact';
import { ContactsService } from '../../../shared/services/contact.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { UserDataService } from '../../../shared/services/auth/userData.service';
import { ReviewService } from '../../../shared/services/review.service';

@Component({
  selector: 'review-request',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-request.component.html',
  styleUrl: './review-request.component.css'
})
export class ReviewRequestComponent implements OnInit {

  @Input() caseId: string | null = null;
  @Input() stage: number | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSend = new EventEmitter<any>();

  icons = Icons;
  threatAssessmentTeam: IThreatAssessmentTeam[] = [];
  usersList: IThreatAssessmentTeam[] = [];
  selectedMembers: IThreatAssessmentTeam[] = [];
  currentBuildingId: string | null = null;
  currentUserId: number | null = null;

  loadingContacts: boolean = false;
  loadingTeam: boolean = false;
  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private contactsService: ContactsService,
    private reviewService: ReviewService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUserId = this.userDataService.getCurrentUser()?.user_id || null;
    this.loadUsers();
  }

  loadUsers(): void {
    this.loading = true;
    if (this.currentBuildingId) {
      this.contactsService.getUsers(this.currentBuildingId).subscribe({
        next: (response) => {
          this.loading = false;
          this.usersList = response;
          this.loadThreatAssessmentTeamMembers();
        },
        error: (error) => {
          this.loading = false;
          console.error('Error fetching users:', error.message);
        },
      });
    }
  }  

  loadThreatAssessmentTeamMembers(): void {
    this.loadingTeam = true;
    this.updateLoadingState();
    if (this.caseId) {
      this.contactsService.getThreatAssessmentTeam(this.caseId).subscribe({
        next: (res) => {
          this.loadingTeam = false;
          this.updateLoadingState();
          if (res.found !== false) {
            this.threatAssessmentTeam = res.team
              .map((item: any) => this.usersList.find(contact => contact.user_id === item.user_id))
              .filter((contact: IThreatAssessmentTeam | undefined): contact is IThreatAssessmentTeam => contact !== undefined);
          }
          if (res.found === false) {
            console.log('No threat assessment team found');
          }
        },
        error: (err) => {
          this.loadingTeam = false;
          this.updateLoadingState();
          console.error(err);
        }
      });
    }
  }

  isMembersSelected(member: any): boolean {
    return this.selectedMembers.some(selectedMember => selectedMember.user_id === member.user_id);
  }
  
  updateLoadingState() {
    this.loading = this.loadingContacts || this.loadingTeam;
  }

  
  addMemberToRequest(member: IThreatAssessmentTeam): void {
    const index = this.selectedMembers.findIndex(
      selected => selected.user_id === member.user_id
    );
  
    if (index === -1) {
      this.selectedMembers.push(member);
    } else {
      this.selectedMembers.splice(index, 1);
    }
  }

  handleSendRequest(): void {
    if (this.selectedMembers.length > 0) {
      this.loading = true;
      const data = {
        case_id: this.caseId,
        building_id: this.currentBuildingId,
        section_review_type: this.stage,
        reviewers_list: this.selectedMembers.map(member => member.user_id)
      }
      if (data) {
        this.reviewService.requestReview(data).subscribe({
          next: (response) => {
            this.loading = false;
            this.onSend.emit({'type': 'success', 'message': 'This occurred after requesting a review.'});
          },
          error: (error) => {
            this.loading = false;
            console.error('Request Review Error:', error);
            this.onSend.emit({'type': 'failed', 'message': error.message});
          }
        });
      }
    }
  }
  
  handleCloseTeam(): void {
    this.onClose.emit();
  }
}
